import React, { useState, useEffect } from 'react';
import axios from 'axios';
import BannerImages from '../../components/BannerImage/BannerImages';
import BannerUpdate from '../../components/BannerUpdate/BannerUpadate';
import './Stories.css';
import API_URL from '../../api/ExamCalendarApi';

const Stories = () => {
  const [successStories, setSuccessStories] = useState([]);
  const [form, setForm] = useState({
    name: '',
    achievement: '',
    photo: null,
    id: null,
  });
  const [isEditing, setIsEditing] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetchSuccessStories();
  }, []);

  // Fetch success stories from the API
  const fetchSuccessStories = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/success-stories/get-success-stories`);
      setSuccessStories(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch success stories');
      setLoading(false);
    }
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
  };

  // Handle file input change
  const handleFileChange = (e) => {
    setForm({ ...form, photo: e.target.files[0] });
  };

  // Handle form submission (create or update)
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.achievement) {
      setError('Name and achievement are required.');
      return;
    }

    try {
      const formData = new FormData();
      formData.append('name', form.name);
      formData.append('achievement', form.achievement);
      if (form.photo) {
        formData.append('photo', form.photo);
      }

      setLoading(true);

      if (isEditing) {
        // Update success story
        await axios.put(`${API_URL}/success-stories/update-success-story/${form.id}`, formData);
      } else {
        // Create new success story
        await axios.post(`${API_URL}/success-stories/add-success-story`, formData);
      }

      fetchSuccessStories(); // Refresh list
      resetForm();
      setLoading(false);
    } catch (err) {
      setError('Failed to submit success story');
      setLoading(false);
    }
  };

  // Edit a success story
  const handleEdit = (story) => {
    setForm({
      name: story.name,
      achievement: story.achievement,
      photo: null,
      id: story._id,
    });
    setIsEditing(true);
    window.scrollTo(0, 0); // Scroll to the form for better UX
  };

  // Delete success story
  const handleDelete = async (id) => {
    try {
      setLoading(true);
      await axios.delete(`${API_URL}/success-stories/delete-success-story/${id}`);
      fetchSuccessStories(); // Refresh list
      setLoading(false);
    } catch (err) {
      setError('Failed to delete success story');
      setLoading(false);
    }
  };

  // Reset form after submission or cancel
  const resetForm = () => {
    setForm({
      name: '',
      achievement: '',
      photo: null,
      id: null,
    });
    setIsEditing(false);
  };

  return (
    <div className="admin-successstories-container">
      <div className='admin-successstories-section'>
      <h2 className='admin-successstories-h2-title'>Success Stories</h2>
      <h3 className='admin-successstories-h2-title'>Update Banner Image</h3>
      <BannerUpdate pageName="successstories"/>

      {error && <div className="admin-successstories-alert">{error}</div>}

      {/* Form for Adding/Editing Success Stories */}
      <form onSubmit={handleSubmit} className="admin-successstories-form">
        <div className="admin-successstories-form-group">
          <label className="admin-successstories-form-label">Name:</label>
          <input
            type="text"
            name="name"
            value={form.name}
            onChange={handleInputChange}
            className="admin-successstories-form-control"
            required
          />
        </div>
        <div className="admin-successstories-form-group">
          <label className="admin-successstories-form-label">Achievement:</label>
          <textarea
            name="achievement"
            value={form.achievement}
            onChange={handleInputChange}
            className="admin-successstories-form-control"
            required
          />
        </div>
        <div className="admin-successstories-form-group">
          <label className="admin-successstories-form-label">Photo:</label>
          <input
            type="file"
            name="photo"
            onChange={handleFileChange}
            className="admin-successstories-form-control"
          />
        </div>
        <button type="submit" className="admin-successstories-btn-primary">
          {isEditing ? 'Update Story' : 'Add Story'}
        </button>
        {isEditing && (
          <button type="button" className="admin-successstories-btn-secondary" onClick={resetForm}>
            Cancel
          </button>
        )}
      </form>

      {/* Loading indicator */}
      {loading && <p>Loading...</p>}

      {/* Success Stories List */}
      <div className="admin-successstories-list">
        <h3 className="admin-successstories-h2-title">All Success Stories</h3>
        <div className="admin-successstories-row">
          {successStories.map((story) => (
            <div className="admin-successstories-col" key={story._id}>
              <div className="admin-successstories-card">
                <img
                  src={story.photo}
                  alt="Success Story"
                  className="admin-successstories-card-img"
                />
                <div className="admin-successstories-card-body">
                  <h5 className="admin-successstories-card-title">{story.name}</h5>
                  <p className="admin-successstories-card-text">{story.achievement}</p>
                </div>
                <div className="admin-successstories-card-footer">
                  <button
                    className="admin-successstories-btn-warning"
                    onClick={() => handleEdit(story)}
                  >
                    Edit
                  </button>
                  <button
                    className="admin-successstories-btn-danger"
                    onClick={() => handleDelete(story._id)}
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
    </div>
  );
};

export default Stories;
